// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Botões e ícones do RDO com as cores anteriores à paleta da marca (b5f64725).
 * O botão primário do portal (Button variant=primary) continua laranja.
 * Estas classes cobrem o que era azul, índigo, roxo, céu ou violeta no RDO:
 * botões, ícones e badges de status/etapa.
 */

.rdo-btn-azul {
  background-color: var(--color-blue-600);
  color: #fff;
}

.rdo-btn-indigo {
  background-color: var(--color-indigo-600);
  color: #fff;
}

.rdo-aba-azul {
  color: var(--color-blue-700);
}

.dark .rdo-aba-azul {
  color: var(--color-blue-300);
}

.rdo-aba-roxa {
  color: var(--color-purple-700);
}

.dark .rdo-aba-roxa {
  color: var(--color-purple-300);
}

.rdo-link-azul {
  color: var(--color-blue-600);
}

.rdo-link-azul:hover {
  color: var(--color-blue-800);
  text-decoration: underline;
}

.dark .rdo-link-azul {
  color: var(--color-blue-400);
}

.dark .rdo-link-azul:hover {
  color: var(--color-blue-300);
}

.rdo-link-azul-simples {
  color: var(--color-blue-600);
}

.rdo-link-azul-simples:hover {
  text-decoration: underline;
}

.rdo-link-azul-700 {
  color: var(--color-blue-700);
}

.rdo-link-azul-700:hover {
  text-decoration: underline;
}

.rdo-btn-icone-azul {
  color: var(--color-blue-600);
}

.rdo-btn-icone-azul:hover {
  background-color: var(--color-blue-50);
}

.dark .rdo-btn-icone-azul {
  color: var(--color-blue-400);
}

.dark .rdo-btn-icone-azul:hover {
  background-color: color-mix(
    in oklab,
    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 40%,
    transparent
  );
}

.rdo-icone-azul {
  color: var(--color-blue-700);
}

.rdo-icone-azul-suave {
  color: var(--color-blue-700);
}

.dark .rdo-icone-azul-suave {
  color: var(--color-blue-400);
}

.rdo-icone-ceu {
  color: var(--color-sky-700, oklch(50% 0.134 242.749));
}

.dark .rdo-icone-ceu {
  color: var(--color-sky-400, oklch(74.6% 0.16 232.661));
}

.rdo-icone-violeta {
  color: var(--color-violet-700, oklch(49.1% 0.27 292.581));
}

.dark .rdo-icone-violeta {
  color: var(--color-violet-400, oklch(70.2% 0.183 293.541));
}

.rdo-check-azul {
  color: var(--color-blue-600);
  accent-color: var(--color-blue-600);
}

.rdo-marca-azul {
  border-color: var(--color-blue-200);
  background-color: var(--color-blue-50);
}

.dark .rdo-marca-azul {
  border-color: var(--color-blue-800);
  background-color: color-mix(
    in oklab,
    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 50%,
    transparent
  );
}

.rdo-marca-azul-ativa {
  border-color: var(--color-blue-500);
  background-color: var(--color-blue-500);
}

.rdo-linha-azul {
  background-color: var(--color-blue-50);
}

.rdo-linha-azul:hover {
  background-color: color-mix(in oklab, var(--color-blue-100) 80%, transparent);
}

.dark .rdo-linha-azul {
  background-color: color-mix(
    in oklab,
    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 35%,
    transparent
  );
}

.dark .rdo-linha-azul:hover {
  background-color: color-mix(
    in oklab,
    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 50%,
    transparent
  );
}

.rdo-badge-azul {
  background-color: var(--color-blue-100);
  color: var(--color-blue-800);
}

.dark .rdo-badge-azul {
  background-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);
  color: var(--color-blue-200);
}

.rdo-badge-etapa-montagem {
  background-color: var(--color-blue-100);
  color: var(--color-blue-800);
}

.dark .rdo-badge-etapa-montagem {
  background-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);
  color: var(--color-blue-300);
}

.rdo-badge-indigo {
  background-color: var(--color-indigo-100);
  color: var(--color-indigo-800);
}

.dark .rdo-badge-indigo {
  background-color: color-mix(in oklab, var(--color-indigo-900) 40%, transparent);
  color: var(--color-indigo-200);
}

.rdo-badge-ceu {
  background-color: var(--color-sky-100, oklch(95.1% 0.026 236.824));
  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));
}

.dark .rdo-badge-ceu {
  background-color: color-mix(
    in oklab,
    var(--color-sky-900, oklch(39.1% 0.09 240.876)) 40%,
    transparent
  );
  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));
}

.rdo-badge-violeta {
  background-color: var(--color-violet-100);
  color: var(--color-violet-800);
}

.dark .rdo-badge-violeta {
  background-color: color-mix(
    in oklab,
    var(--color-violet-900, oklch(38% 0.189 293.745)) 40%,
    transparent
  );
  color: var(--color-violet-200, oklch(89.4% 0.057 293.283));
}

.rdo-badge-roxa {
  background-color: var(--color-purple-100);
  color: var(--color-purple-800);
}

.dark .rdo-badge-roxa {
  background-color: color-mix(in oklab, var(--color-purple-900) 60%, transparent);
  color: var(--color-purple-200);
}

.rdo-badge-portaldoc {
  background-color: var(--color-sky-100, oklch(95.1% 0.026 236.824));
  color: var(--color-sky-700, oklch(50% 0.134 242.749));
}

.dark .rdo-badge-portaldoc {
  background-color: color-mix(
    in oklab,
    var(--color-sky-900, oklch(39.1% 0.09 240.876)) 30%,
    transparent
  );
  color: var(--color-sky-300, oklch(82.8% 0.111 230.318));
}

.rdo-badge-sub {
  background-color: var(--color-sky-200, oklch(90.1% 0.058 230.902));
  color: var(--color-sky-900, oklch(39.1% 0.09 240.876));
}

.dark .rdo-badge-sub {
  background-color: var(--color-sky-800, oklch(44.3% 0.11 240.79));
  color: var(--color-sky-100, oklch(95.1% 0.026 236.824));
}

.rdo-ponto-azul {
  background-color: var(--color-blue-600);
}

.dark .rdo-ponto-azul {
  background-color: var(--color-blue-400);
}

.rdo-ponto-roxa {
  background-color: var(--color-purple-600);
}

.dark .rdo-ponto-roxa {
  background-color: var(--color-purple-400, oklch(71.4% 0.203 305.504));
}

.rdo-selo-montagem {
  background-color: color-mix(in oklab, var(--color-blue-600) 90%, transparent);
}

.rdo-chip-violeta {
  border-color: var(--color-violet-200, oklch(89.4% 0.057 293.283));
  background-color: var(--color-violet-50);
  color: var(--color-violet-800);
}

.dark .rdo-chip-violeta {
  border-color: var(--color-violet-700, oklch(49.1% 0.27 292.581));
  background-color: color-mix(
    in oklab,
    var(--color-violet-950, oklch(28.3% 0.141 291.089)) 50%,
    transparent
  );
  color: var(--color-violet-200, oklch(89.4% 0.057 293.283));
}

.rdo-chip-ceu {
  border-color: var(--color-sky-200, oklch(90.1% 0.058 230.902));
  background-color: var(--color-sky-50, oklch(97.7% 0.013 236.62));
  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));
}

.dark .rdo-chip-ceu {
  border-color: var(--color-sky-700, oklch(50% 0.134 242.749));
  background-color: color-mix(
    in oklab,
    var(--color-sky-950, oklch(29.3% 0.066 243.157)) 50%,
    transparent
  );
  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));
}

.rdo-painel-roxa {
  border-color: color-mix(in oklab, var(--color-purple-200) 70%, transparent);
  background-color: color-mix(in oklab, var(--color-purple-50) 20%, transparent);
}

.dark .rdo-painel-roxa {
  border-color: color-mix(in oklab, var(--color-purple-900) 40%, transparent);
  background-color: color-mix(
    in oklab,
    var(--color-purple-950, oklch(29.1% 0.149 302.717)) 10%,
    transparent
  );
}

.rdo-painel-azul {
  border-color: color-mix(in oklab, var(--color-blue-200) 70%, transparent);
  background-color: color-mix(in oklab, var(--color-blue-50) 20%, transparent);
}

.dark .rdo-painel-azul {
  border-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);
  background-color: color-mix(
    in oklab,
    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 10%,
    transparent
  );
}

.rdo-caixa-sub {
  border-color: var(--color-sky-300, oklch(82.8% 0.111 230.318));
  background-color: color-mix(
    in oklab,
    var(--color-sky-50, oklch(97.7% 0.013 236.62)) 80%,
    transparent
  );
}

.dark .rdo-caixa-sub {
  border-color: var(--color-sky-700, oklch(50% 0.134 242.749));
  background-color: color-mix(
    in oklab,
    var(--color-sky-950, oklch(29.3% 0.066 243.157)) 40%,
    transparent
  );
}

.rdo-titulo-sub {
  color: var(--color-sky-950, oklch(29.3% 0.066 243.157));
}

.dark .rdo-titulo-sub {
  color: var(--color-sky-100, oklch(95.1% 0.026 236.824));
}

.rdo-rotulo-sub {
  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));
}

.dark .rdo-rotulo-sub {
  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));
}

.dark .rdo-meta-sub {
  color: color-mix(in oklab, var(--color-sky-200, oklch(90.1% 0.058 230.902)) 80%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/styles/rdo-cores-legadas.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC;;;;GAIC;AACH;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,+EAA+E;EAC/E,8BAA8B;AAChC;;AAEA;EACE,kEAAkE;EAClE,qDAAqD;AACvD;;AAEA;EACE;;;;GAIC;EACD,uDAAuD;AACzD;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE;;;;GAIC;EACD,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,+EAA+E;EAC/E,8BAA8B;AAChC;;AAEA;EACE,kEAAkE;EAClE,qDAAqD;AACvD;;AAEA;EACE;;;;GAIC;EACD,uDAAuD;AACzD;;AAEA;EACE,kEAAkE;EAClE,sDAAsD;AACxD;;AAEA;EACE,gEAAgE;EAChE,uDAAuD;AACzD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,iEAAiE;EACjE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,gEAAgE;EAChE;;;;GAIC;EACD,0DAA0D;AAC5D;;AAEA;EACE,8DAA8D;EAC9D,gEAAgE;EAChE,qDAAqD;AACvD;;AAEA;EACE,4DAA4D;EAC5D;;;;GAIC;EACD,uDAAuD;AACzD;;AAEA;EACE,2EAA2E;EAC3E,8EAA8E;AAChF;;AAEA;EACE,2EAA2E;EAC3E;;;;GAIC;AACH;;AAEA;EACE,yEAAyE;EACzE,4EAA4E;AAC9E;;AAEA;EACE,yEAAyE;EACzE;;;;GAIC;AACH;;AAEA;EACE,8DAA8D;EAC9D;;;;GAIC;AACH;;AAEA;EACE,4DAA4D;EAC5D;;;;GAIC;AACH;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,6FAA6F;AAC/F","sourcesContent":["/*\n * Botões e ícones do RDO com as cores anteriores à paleta da marca (b5f64725).\n * O botão primário do portal (Button variant=primary) continua laranja.\n * Estas classes cobrem o que era azul, índigo, roxo, céu ou violeta no RDO:\n * botões, ícones e badges de status/etapa.\n */\n\n.rdo-btn-azul {\n  background-color: var(--color-blue-600);\n  color: #fff;\n}\n\n.rdo-btn-indigo {\n  background-color: var(--color-indigo-600);\n  color: #fff;\n}\n\n.rdo-aba-azul {\n  color: var(--color-blue-700);\n}\n\n.dark .rdo-aba-azul {\n  color: var(--color-blue-300);\n}\n\n.rdo-aba-roxa {\n  color: var(--color-purple-700);\n}\n\n.dark .rdo-aba-roxa {\n  color: var(--color-purple-300);\n}\n\n.rdo-link-azul {\n  color: var(--color-blue-600);\n}\n\n.rdo-link-azul:hover {\n  color: var(--color-blue-800);\n  text-decoration: underline;\n}\n\n.dark .rdo-link-azul {\n  color: var(--color-blue-400);\n}\n\n.dark .rdo-link-azul:hover {\n  color: var(--color-blue-300);\n}\n\n.rdo-link-azul-simples {\n  color: var(--color-blue-600);\n}\n\n.rdo-link-azul-simples:hover {\n  text-decoration: underline;\n}\n\n.rdo-link-azul-700 {\n  color: var(--color-blue-700);\n}\n\n.rdo-link-azul-700:hover {\n  text-decoration: underline;\n}\n\n.rdo-btn-icone-azul {\n  color: var(--color-blue-600);\n}\n\n.rdo-btn-icone-azul:hover {\n  background-color: var(--color-blue-50);\n}\n\n.dark .rdo-btn-icone-azul {\n  color: var(--color-blue-400);\n}\n\n.dark .rdo-btn-icone-azul:hover {\n  background-color: color-mix(\n    in oklab,\n    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 40%,\n    transparent\n  );\n}\n\n.rdo-icone-azul {\n  color: var(--color-blue-700);\n}\n\n.rdo-icone-azul-suave {\n  color: var(--color-blue-700);\n}\n\n.dark .rdo-icone-azul-suave {\n  color: var(--color-blue-400);\n}\n\n.rdo-icone-ceu {\n  color: var(--color-sky-700, oklch(50% 0.134 242.749));\n}\n\n.dark .rdo-icone-ceu {\n  color: var(--color-sky-400, oklch(74.6% 0.16 232.661));\n}\n\n.rdo-icone-violeta {\n  color: var(--color-violet-700, oklch(49.1% 0.27 292.581));\n}\n\n.dark .rdo-icone-violeta {\n  color: var(--color-violet-400, oklch(70.2% 0.183 293.541));\n}\n\n.rdo-check-azul {\n  color: var(--color-blue-600);\n  accent-color: var(--color-blue-600);\n}\n\n.rdo-marca-azul {\n  border-color: var(--color-blue-200);\n  background-color: var(--color-blue-50);\n}\n\n.dark .rdo-marca-azul {\n  border-color: var(--color-blue-800);\n  background-color: color-mix(\n    in oklab,\n    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 50%,\n    transparent\n  );\n}\n\n.rdo-marca-azul-ativa {\n  border-color: var(--color-blue-500);\n  background-color: var(--color-blue-500);\n}\n\n.rdo-linha-azul {\n  background-color: var(--color-blue-50);\n}\n\n.rdo-linha-azul:hover {\n  background-color: color-mix(in oklab, var(--color-blue-100) 80%, transparent);\n}\n\n.dark .rdo-linha-azul {\n  background-color: color-mix(\n    in oklab,\n    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 35%,\n    transparent\n  );\n}\n\n.dark .rdo-linha-azul:hover {\n  background-color: color-mix(\n    in oklab,\n    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 50%,\n    transparent\n  );\n}\n\n.rdo-badge-azul {\n  background-color: var(--color-blue-100);\n  color: var(--color-blue-800);\n}\n\n.dark .rdo-badge-azul {\n  background-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);\n  color: var(--color-blue-200);\n}\n\n.rdo-badge-etapa-montagem {\n  background-color: var(--color-blue-100);\n  color: var(--color-blue-800);\n}\n\n.dark .rdo-badge-etapa-montagem {\n  background-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);\n  color: var(--color-blue-300);\n}\n\n.rdo-badge-indigo {\n  background-color: var(--color-indigo-100);\n  color: var(--color-indigo-800);\n}\n\n.dark .rdo-badge-indigo {\n  background-color: color-mix(in oklab, var(--color-indigo-900) 40%, transparent);\n  color: var(--color-indigo-200);\n}\n\n.rdo-badge-ceu {\n  background-color: var(--color-sky-100, oklch(95.1% 0.026 236.824));\n  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));\n}\n\n.dark .rdo-badge-ceu {\n  background-color: color-mix(\n    in oklab,\n    var(--color-sky-900, oklch(39.1% 0.09 240.876)) 40%,\n    transparent\n  );\n  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));\n}\n\n.rdo-badge-violeta {\n  background-color: var(--color-violet-100);\n  color: var(--color-violet-800);\n}\n\n.dark .rdo-badge-violeta {\n  background-color: color-mix(\n    in oklab,\n    var(--color-violet-900, oklch(38% 0.189 293.745)) 40%,\n    transparent\n  );\n  color: var(--color-violet-200, oklch(89.4% 0.057 293.283));\n}\n\n.rdo-badge-roxa {\n  background-color: var(--color-purple-100);\n  color: var(--color-purple-800);\n}\n\n.dark .rdo-badge-roxa {\n  background-color: color-mix(in oklab, var(--color-purple-900) 60%, transparent);\n  color: var(--color-purple-200);\n}\n\n.rdo-badge-portaldoc {\n  background-color: var(--color-sky-100, oklch(95.1% 0.026 236.824));\n  color: var(--color-sky-700, oklch(50% 0.134 242.749));\n}\n\n.dark .rdo-badge-portaldoc {\n  background-color: color-mix(\n    in oklab,\n    var(--color-sky-900, oklch(39.1% 0.09 240.876)) 30%,\n    transparent\n  );\n  color: var(--color-sky-300, oklch(82.8% 0.111 230.318));\n}\n\n.rdo-badge-sub {\n  background-color: var(--color-sky-200, oklch(90.1% 0.058 230.902));\n  color: var(--color-sky-900, oklch(39.1% 0.09 240.876));\n}\n\n.dark .rdo-badge-sub {\n  background-color: var(--color-sky-800, oklch(44.3% 0.11 240.79));\n  color: var(--color-sky-100, oklch(95.1% 0.026 236.824));\n}\n\n.rdo-ponto-azul {\n  background-color: var(--color-blue-600);\n}\n\n.dark .rdo-ponto-azul {\n  background-color: var(--color-blue-400);\n}\n\n.rdo-ponto-roxa {\n  background-color: var(--color-purple-600);\n}\n\n.dark .rdo-ponto-roxa {\n  background-color: var(--color-purple-400, oklch(71.4% 0.203 305.504));\n}\n\n.rdo-selo-montagem {\n  background-color: color-mix(in oklab, var(--color-blue-600) 90%, transparent);\n}\n\n.rdo-chip-violeta {\n  border-color: var(--color-violet-200, oklch(89.4% 0.057 293.283));\n  background-color: var(--color-violet-50);\n  color: var(--color-violet-800);\n}\n\n.dark .rdo-chip-violeta {\n  border-color: var(--color-violet-700, oklch(49.1% 0.27 292.581));\n  background-color: color-mix(\n    in oklab,\n    var(--color-violet-950, oklch(28.3% 0.141 291.089)) 50%,\n    transparent\n  );\n  color: var(--color-violet-200, oklch(89.4% 0.057 293.283));\n}\n\n.rdo-chip-ceu {\n  border-color: var(--color-sky-200, oklch(90.1% 0.058 230.902));\n  background-color: var(--color-sky-50, oklch(97.7% 0.013 236.62));\n  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));\n}\n\n.dark .rdo-chip-ceu {\n  border-color: var(--color-sky-700, oklch(50% 0.134 242.749));\n  background-color: color-mix(\n    in oklab,\n    var(--color-sky-950, oklch(29.3% 0.066 243.157)) 50%,\n    transparent\n  );\n  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));\n}\n\n.rdo-painel-roxa {\n  border-color: color-mix(in oklab, var(--color-purple-200) 70%, transparent);\n  background-color: color-mix(in oklab, var(--color-purple-50) 20%, transparent);\n}\n\n.dark .rdo-painel-roxa {\n  border-color: color-mix(in oklab, var(--color-purple-900) 40%, transparent);\n  background-color: color-mix(\n    in oklab,\n    var(--color-purple-950, oklch(29.1% 0.149 302.717)) 10%,\n    transparent\n  );\n}\n\n.rdo-painel-azul {\n  border-color: color-mix(in oklab, var(--color-blue-200) 70%, transparent);\n  background-color: color-mix(in oklab, var(--color-blue-50) 20%, transparent);\n}\n\n.dark .rdo-painel-azul {\n  border-color: color-mix(in oklab, var(--color-blue-900) 40%, transparent);\n  background-color: color-mix(\n    in oklab,\n    var(--color-blue-950, oklch(28.2% 0.091 267.935)) 10%,\n    transparent\n  );\n}\n\n.rdo-caixa-sub {\n  border-color: var(--color-sky-300, oklch(82.8% 0.111 230.318));\n  background-color: color-mix(\n    in oklab,\n    var(--color-sky-50, oklch(97.7% 0.013 236.62)) 80%,\n    transparent\n  );\n}\n\n.dark .rdo-caixa-sub {\n  border-color: var(--color-sky-700, oklch(50% 0.134 242.749));\n  background-color: color-mix(\n    in oklab,\n    var(--color-sky-950, oklch(29.3% 0.066 243.157)) 40%,\n    transparent\n  );\n}\n\n.rdo-titulo-sub {\n  color: var(--color-sky-950, oklch(29.3% 0.066 243.157));\n}\n\n.dark .rdo-titulo-sub {\n  color: var(--color-sky-100, oklch(95.1% 0.026 236.824));\n}\n\n.rdo-rotulo-sub {\n  color: var(--color-sky-800, oklch(44.3% 0.11 240.79));\n}\n\n.dark .rdo-rotulo-sub {\n  color: var(--color-sky-200, oklch(90.1% 0.058 230.902));\n}\n\n.dark .rdo-meta-sub {\n  color: color-mix(in oklab, var(--color-sky-200, oklch(90.1% 0.058 230.902)) 80%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
